import React, { useEffect } from "react";
import { useNavigate } from "react-router";
import { useErrorBoundary } from "react-error-boundary";

import Button from "../../../shared/components/Buttons/Button";
import {
  buttonNameConstants,
  buttonTypeConstants,
  globalConstants,
  printerConstants,
  routesPathConstants,
  transactionConstants,
} from "../../../constants";
import ErrorIcon from "../../../assets/images/ErrorIcon.svg";
import { clearStorage } from "../../../system/storage";
import { connect } from "react-redux";
import {
  handleAddBatchInventoryPark,
  handlePayClick,
} from "../../../shared/utility";
import { inventoryActions, transactionActions } from "../../../redux/actions";

const ErrorScreen = ({
  user,
  outlet,
  transaction,
  newTradePark,
  currentStore,
  addBatchInventory,
  invoiceBatchInventory,
  addBatchInventoryDraft,
  addTradeBatchInventory,
}) => {
  const { resetBoundary } = useErrorBoundary();
  const navigate = useNavigate();

  const handleButtonClick = (isReport) => {
    resetBoundary();
    clearStorage(false, true, false, [
      printerConstants.LOCAL_DEVICE_IP,
      globalConstants.COMPANY_DOMAIN_URL,
      process.env.REACT_APP_COMPANY_PAYLOAD,
    ]);
    if (isReport) {
      navigate(routesPathConstants.REPORT_ISSUE, {
        state: { errorScreenUrl: window.location.href },
      });
    } else {
      navigate(routesPathConstants.DEFAULT_PATH);
    }
  };

  useEffect(() => {
    if (addBatchInventory?.length > 0) {
      handleAddBatchInventoryPark(
        addBatchInventory,
        currentStore,
        addBatchInventoryDraft
      );
    }

    if (addTradeBatchInventory?.length > 0) {
      const { newTradeData } = transaction;
      handlePayClick(
        transactionConstants.DRAFT,
        currentStore,
        newTradeData,
        0,
        addTradeBatchInventory,
        outlet,
        newTradePark,
        navigate,
        () => {},
        () => {},
        transactionActions,
        user
      );
    }
  }, []);

  console.log(
    `Error Screen: addBatchInventory-${addBatchInventory?.length}, addTradeBatchInventory-${addTradeBatchInventory?.length}, invoiceBatchInventory-${invoiceBatchInventory?.length}`
  );

  return (
    <div className="vw-100 vh-100 d-flex flex-column gap-3 justify-content-center align-items-center">
      <img src={ErrorIcon} className="error-icon" />
      <h2> Something went wrong! </h2>
      <h5 className="d-flex gap-2">
        Report your problem at
        <a
          href={`mailto:${process.env.REACT_APP_SUPPORT_EMAIL}`}
          className="text-decoration-underline cursor-pointer"
        >
          <h5>{process.env.REACT_APP_SUPPORT_EMAIL}</h5>
        </a>
      </h5>
      <span className="d-flex align-items-center justify-content-center gap-2"></span>
      <div className="d-flex  justify-content-center align-items-center gap-2">
        <Button
          label={buttonNameConstants.REPORT_PROBLEM}
          handleClick={() => handleButtonClick(true)}
        />
        <Button
          label={buttonNameConstants.BACK}
          handleClick={() => handleButtonClick(false)}
          buttonType={buttonTypeConstants.GHOST_BUTTON}
        />
      </div>
    </div>
  );
};

//-------Mapping the component's props to the reducer's state
const mapStateToProps = (state) => ({
  outlet: state.outlet,
  transaction: state.transaction,
  user: state.authentication.user,
  currentStore: state.store.currentStore,
  addBatchInventory: state.inventory.addBatchInventory,
  invoiceBatchInventory: state.invoice.invoiceBatchInventory,
  addTradeBatchInventory: state.transaction.addTradeBatchInventory,
});

//-------Mapping the component's props to the related actions
const mapDispatchToProps = (dispatch) => ({
  addBatchInventoryDraft: (data) =>
    dispatch(inventoryActions.addBatchInventoryDraft(data)),
  newTradePark: (data, storeId) =>
    dispatch(transactionActions.newTradePark(data, storeId)),
});

//-------Export report Component
export default connect(mapStateToProps, mapDispatchToProps)(ErrorScreen);
